import React from 'react';
import OrganizationChartReact from '../../OrganizationChart/OrganizationChartReact';

const OrganizationChartIndex = () => {
  return (
    <>
      <OrganizationChartReact />
    </>
  );
};

export default OrganizationChartIndex;
